<template>
  <section class="row Projects">
    <div class="row middle-xs">
      <FadeRight appear :duration="500" :delay="300">
        <h1 class="col-xs-9 col-sm-7 title">&mdash; Projects.</h1>
      </FadeRight>
    </div>
    <div class="row">
      <!-- <transition
        name="switchImage"
        tag="span"
        class="col-sm-6 imageContainer"
      >-->
      <div class="col-sm-6">
        <div class="row middle imageContainer">
          <transition-group name="slider" tag="div">
            <!-- <img v-for="item in prevZ" :key="projects[item].id" :src="imageSrc(projects[item].Title)" :ref="'image' + projects[item].id" class="landingImage"> -->
            <img
              v-for="number in [$store.state.selectedProjectKey]"
              :key="number"
              :src="imageSrc($store.state.projects[number].Title)"
              :alt="$store.state.projects[number].Title + ' hero image'"
              class="landingImage"
            />
          </transition-group>
          <!-- <img
            v-for="item in projects"
            class="landingImage"
            :key="item.id"
            :src="imageSrc(item.Title)"
            :ref="'image' + item.id"
          >-->
        </div>
        <!-- </transition> -->
      </div>
      <div class="col-xs col-sm-3">
        <ProjectList section="Digital." :projects="'Digital'" />
        <ProjectList section="Physical." :projects="'Physical'" />
      </div>
    </div>
  </section>
</template>
<script>
import FadeRight from "@/transitions/FadeRight.vue";
import ProjectList from "@/components/ProjectList.vue";

export default {
  name: "ProjectsSection",
  components: {
    FadeRight,
    ProjectList
  },
  data: function() {
    return {
      rendered: false
    };
  },
  computed: {
    numProjects() {
      return this.$store.getters.numProjects;
    }
  },
  methods: {
    imageSrc: function(Str) {
      return require("@/assets/" +
        Str.replace(/[^\w\d]/g, "") +
        "_Hero" +
        ".jpg");
    }
  }
};
</script>

<style scoped lang="scss">
// * {
//   border: 1px solid red!important;
// }

// @mixin margins {
//   @for $i from 1 through 7 {
//     &:nth-child(#{$i}) {
//       @if $i != 1 {
//         opacity: 0;
//       }
//       // left: #{6-$i}rem;
//       // top: #{(6-$i)}rem;
//       // z-index: #{99-$i};
//       // transform: translate3d(#{(6-$i)*.5}rem, 0rem, #{10-$i}px);
//     }
//   }
// }

// 'z-index': 99 - projects.Projects[item].id,
// :style="imageMargins(projects[item].id)"

.Projects {
  .row {
    padding: 0;
  }
  .title {
    font-size: 3rem;
    text-align: left;
    @include respond-to(sm) {
      text-align: right;
    }
    // max-height: 15vh;
    // vertical-align: center;
    margin-bottom: 2rem;
    backface-visibility: hidden;
  }
  .imageContainer {
    position: relative;
    // top: -6rem;
    // margin-top: 6rem;
    margin-bottom: 3rem;
    transform-style: preserve-3d;
    // height: auto;
    // height: 100%;
    // overflow: hidden;
    padding: 0;
    .landingImage {
      border: 1px solid transparent;
      // @include margins;
      position: absolute;
      // transform-origin: center top;
    }
  }
  .landingImage {
    // margin-left: (-1 * ($gutter + $content-margins));
    max-width: 95%;
    // height: 50%;
    position: absolute;
    backface-visibility: hidden;
    // box-shadow: 0 0 16px rgba($almost-black, 0.02);
  }
}

.switchImage {
  backface-visibility: hidden;
}

.slider-move {
  transition: opacity 0.75s ease-in-out;
  // animation-name: slidetop;
  // animation-duration: .5s;
}

// @keyframes slidetop {
//   from {
//     opacity: 0;
//   }
//   to {
//     opacity: 1;
//   }
// }

.slider-enter-active,
.slider-leave-active {
  transition: opacity 0.8s ease, visibility 0.8s ease;
  overflow: hidden;
  visibility: visible;
  opacity: 1;
  position: absolute;
}
.slider-enter,
.slider-leave-to {
  opacity: 0;
  visibility: hidden;
}
</style>
